var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardmanagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.04 4.875L2.85 8.325L2.04 11.76L5.055 13.62L6.9 16.635L10.35 15.825L13.8 16.635L15.645 13.62L18.66 11.76L17.85 8.325L18.66 4.875L15.66 3.015L13.8 0L10.35 0.825L6.915 0.015L5.04 3.015L2.04 4.875ZM10.365 14.385C8.7737 14.385 7.24758 13.7529 6.12236 12.6276C4.99714 11.5024 4.365 9.9763 4.365 8.385C4.365 6.7937 4.99714 5.26758 6.12236 4.14236C7.24758 3.01714 8.7737 2.385 10.365 2.385C13.665 2.385 16.35 5.07 16.35 8.37C16.35 11.7 13.665 14.385 10.365 14.385ZM10.335 12.885C7.845 12.885 5.85 10.875 5.85 8.385C5.85 5.91 7.845 3.885 10.335 3.885C12.825 3.885 14.85 5.91 14.85 8.385C14.85 10.875 12.825 12.885 10.335 12.885ZM16.095 14.535L14.175 17.895L11.055 17.19L14.85 25.935L16.95 22.635H20.7L16.095 14.535ZM4.545 14.64L6.42 18.015L9.615 17.25L5.85 25.935L3.75 22.635H0L4.545 14.64Z",
    fill: "#5282F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardmanagement);
export default __webpack_public_path__ + "static/media/rewardmanagement.c6374fb4570783252f7cd6bcb99c0249.svg";
export { ForwardRef as ReactComponent };